module.exports = __webpack_public_path__ + "img/7.d8d9c23d.jpg";